import mixpanel from 'mixpanel-browser'
import { envConfig } from '../../services/envConfig'

const isProd = envConfig.NEXT_PUBLIC_NODE_ENV === 'production'
mixpanel.init(envConfig.NEXT_PUBLIC_MIXPANEL_TOKEN, {
  debug: !isProd,
})

const actions = {
  identify: (id: string) => {
    if (isProd) mixpanel.identify(id)
  },
  alias: (id: string) => {
    if (isProd) mixpanel.alias(id)
  },
  track: (name: string, props: any) => {
    if (isProd) mixpanel.track(name, props)
  },
  reset: () => {
    if (isProd) mixpanel.reset()
  },
  people: {
    set: (props: any) => {
      if (isProd) mixpanel.people.set(props)
    },
  },
}

export const Mixpanel = actions
